import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';
import { ICMS_GROUP_ADDITIONAL_ID } from '../../cms/components/components.config';
import { CUSTOMER_GROUPS, customerGroupVisibilityCmsField } from './customer-groups';
import { CustomerGroupsService } from './customer-groups.service';
import { IfCustomerGroupDirective } from './if-customer-group.directive';
import { IfNotCustomerGroupDirective } from './if-not-customer-group.directive';

ICmsContentService.registerComponentMetaPatch((meta: NICmsContentComponent.IMeta) => {
    // styles are only for non-block components
    if (!meta.block) {
        meta.fields.push({
            ...customerGroupVisibilityCmsField(CUSTOMER_GROUPS),
            key: `${ICMS_GROUP_ADDITIONAL_ID}.visibility`,
            group: ICMS_GROUP_ADDITIONAL_ID
        });
    }
});

const ASSETS = [IfCustomerGroupDirective, IfNotCustomerGroupDirective];

@NgModule({
    imports: ASSETS,
    exports: ASSETS
})
export class CustomerGroupsModule {
    static forRoot(): ModuleWithProviders<CustomerGroupsModule> {
        return {
            ngModule: CustomerGroupsModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: (customerGroupsService: CustomerGroupsService) => {
                        return () => customerGroupsService.appInitializer();
                    },
                    deps: [CustomerGroupsService],
                    multi: true
                }
            ]
        };
    }
}
